const getLastLocSegment = (loc) => {
  if (!Array.isArray(loc)) return null;
  const segments = loc.filter((segment) => typeof segment === 'string' && segment.trim());
  return segments.length ? segments[segments.length - 1] : null;
};

const formatDetailEntry = (entry, isPortuguese) => {
  if (!entry) return null;
  if (typeof entry === 'string' && entry.trim()) return entry;
  if (typeof entry !== 'object') return null;

  const message = typeof entry.msg === 'string' && entry.msg.trim() ? entry.msg.trim() : null;
  const field = getLastLocSegment(entry.loc);
  if (message && field) {
    return isPortuguese
      ? `Parâmetro inválido (${field}): ${message}`
      : `Invalid parameter (${field}): ${message}`;
  }
  if (message) return message;
  if (typeof entry.detail === 'string' && entry.detail.trim()) return entry.detail.trim();
  if (typeof entry.message === 'string' && entry.message.trim()) return entry.message.trim();
  return null;
};

export const getOptionsErrorMessage = (error, fallbackMessage, isPortuguese = false) => {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail.trim();
  }

  if (Array.isArray(detail) && detail.length) {
    const messages = detail
      .map((entry) => formatDetailEntry(entry, isPortuguese))
      .filter(Boolean);
    if (messages.length) {
      return messages.join(' · ');
    }
  }

  if (detail && typeof detail === 'object') {
    const normalized = formatDetailEntry(detail, isPortuguese);
    if (normalized) return normalized;
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  return fallbackMessage;
};

export default getOptionsErrorMessage;